<template>
  <header class="border-b--1px border--solid border--gray border--lighten-2 p--30px pb--26px mb--50px">
    <h1 class="font--28px lh--1">{{label}}</h1>
  </header>
</template>

<script>
export default {
  name: 'admin-page-title',
  props: {
    label: { type: String, required: true }
  }
}
</script>
